import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button, translate } from '@haldor/ui';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as microsoftTeams from "@microsoft/teams-js";

var ConsentButton = /*#__PURE__*/function (_Component) {
  _inherits(ConsentButton, _Component);

  var _super = _createSuper(ConsentButton);

  function ConsentButton(props) {
    var _this;

    _classCallCheck(this, ConsentButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "requestConsent", function () {
      // Split the scopes string into an array
      var scopesArray = _this.props.scopes ? _this.props.scopes.split(';') : [];
      var url = "/authenticate?platform=teams";

      if (scopesArray.length > 0) {
        url += "&scopes=" + scopesArray.join(';');
      }

      console.log(url);
      microsoftTeams.authentication.authenticate({
        url: _this.props.scopes ? "/authenticate?platform=teams" + "&scopes=" + _this.props.scopes : "/authenticate?platform=teams"
      }).then(function (response) {
        if (_this.props.onResponse != null) {
          _this.props.onResponse();
        }
      })["catch"](function (error) {
        console.log("consent failue response", error);
      });
    });

    return _this;
  }

  _createClass(ConsentButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.requestConsent
      }, this.props.translate(this.props.title)));
    }
  }]);

  return ConsentButton;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {})(ConsentButton));